/**
 *
 * Bubbles
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Tooltip } from "antd"
import "./index.less"
/* eslint-disable react/prefer-stateless-function */
class Bubbles extends React.Component {
  render() {
    let { left, right, numbers } = this.props
    left = left || 0
    right = right || 0
    left = 8 * left
    right = 8 * right
    return (
      <Tooltip overlayClassName="tooltipWhite" title={this.props.left}>
        {numbers ? (
          this.props.left
        ) : (
          <div className="BubblesComponent">
            <div style={{ left }} />
            <div style={{ right }} />
          </div>
        )}
      </Tooltip>
    )
  }
}

Bubbles.propTypes = {}
Bubbles.defaultProps = { numbers: false }

export default Bubbles
